import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=40e50590&scoped=true&"
import script from "./CustomSelect.vue?vue&type=script&lang=js&"
export * from "./CustomSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=40e50590&lang=scss&"
import style1 from "./CustomSelect.vue?vue&type=style&index=1&id=40e50590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e50590",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e50590')) {
      api.createRecord('40e50590', component.options)
    } else {
      api.reload('40e50590', component.options)
    }
    module.hot.accept("./CustomSelect.vue?vue&type=template&id=40e50590&scoped=true&", function () {
      api.rerender('40e50590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/core/CustomSelect.vue"
export default component.exports